import React from "react";
import { DescriptionFieldProps} from '@rjsf/utils';

export default function DescriptionFieldTemplate(props: DescriptionFieldProps) {
    const { description, id } = props;
    return (
      <div id={id}>
        {typeof description === 'string' ? (
          <div dangerouslySetInnerHTML={{ __html: description }} />
        ) : (
          description
        )}
      </div>
    );
  }
